export default {
  localeCodes: state => state.locales.map(i => i.code),
}
